import { StatefulLoader } from '@mauriceguest/guest'
import { AbstractAvailabilityLoader } from '../../generated'

export default class AvailabilityLoader extends AbstractAvailabilityLoader {}

/** @constructor @extends {AvailabilityLoader} @suppress {checkTypes} */ function _AvailabilityLoader() {}
AbstractAvailabilityLoader.__implement(AvailabilityLoader, StatefulLoader,
 _AvailabilityLoader.prototype = /** @type {!AvailabilityLoader} */ ({
  async GetAvailability({month,year}) {
   if (!month || !year) return
   const {
    asIAvailabilityLoader:{setState},
    asIStatefulLoader:{fetchJSON},
    props: {HOST,bike_id},
   } = this
   const res = await fetchJSON(`${HOST}/api/booking?bike_id=${bike_id}&year=${year}&month=${month}`)
   const availability = []
   if(res) for (const r of res) {
    const { 'start': start, 'end': end } = r
    availability.push({ start: new Date(start), end: new Date(end) })
   }
   setState({
    availability,
   })
  },
 }),
)
